//  Angular imports
import { InjectionToken } from '@angular/core';

export const WINDOW_TOKEN: InjectionToken<string> = new InjectionToken('Window');
